<template>
    <div v-if="modalOpen || modalInfo.isVisible">
        <div class="overlay" v-if="modalInfo.buttons.length > 1" @click="closeModalInfo"></div>
        <div class="overlay" v-else @click="handleButtonAction(modalInfo.buttons[0].buttonAction)"></div>
        <div class="modal-container">
            <div class="modal-title">
                <fa :icon="modalInfo.icon"></fa>
            </div>
            <div class="modal-body">{{ modalInfo.text }}</div>
            <div class="modal-footer">
                <button v-for="(btn, btnkey) in modalInfo.buttons" :key="btnkey" @click="handleButtonAction(btn.buttonAction)" v-text="btn.buttonText"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ModalInfo',
  props: ['modalOpen'],
  components: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['modalInfo'])
  },
  methods: {
    ...mapActions(['closeModalInfo']),
    handleButtonAction: function (btnAction) {
      if (btnAction) {
        this.$emit(btnAction)
      }
      if (this.modalInfo.isVisible) {
        this.closeModalInfo()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.modal-container {
    position: fixed;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    z-index: 11;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: white;
    height: auto;
    width: fit-content;
    min-width: 50vw;
    padding: 30px;

    .modal-title {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        font-size: 2rem;
    }
    .modal-body {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 0 10px;
    }
    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        gap: 15px;
        button {
            color:white;
            background: var(--primaryColor);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            font-size: 1rem;
            min-width: 90px;
        }
    }
}
.overlay {
        position: fixed;
        top: 0; left: 0;
        height: var(--real-vh);
        width: 100vw;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.21);
        z-index: 10;
    }
</style>
